import React from 'react';
import { GlobalDesignActionLobbyItem, GlobalDesignStyleGroup } from '../types';
import { useGroupsPreview } from '../common/lobby/useGroupsPreview';
import { useGroupComponentProps } from '../common/lobby/useGroupComponentProps';

const getDefaultValue = (group: GlobalDesignStyleGroup) => ({
  fontColor: {
    type: 'HexColor',
    value: '',
  },
  fontSize: {
    value: '',
    unit: '',
  },
  themeName: group.displayName,
  fontFamily: 'Arial',
  isMixedFontColor: false,
  isMixedFontFamily: false,
  isMixedFontSize: false,
});

const TextLobbyItem: GlobalDesignActionLobbyItem = (props) => {
  const GroupPreviewComponent = useGroupsPreview('text', props.group);
  const groupComponentProps = useGroupComponentProps<
    ReturnType<typeof getDefaultValue>,
    'Font'
  >(props.group, getDefaultValue(props.group), (acc, styleValues) => {
    // @ts-expect-error - TODO: ds-types-bump
    if (styleValues.type === 'Length') {
      if (!acc.fontSize?.value) {
        acc.fontSize = {
          // @ts-expect-error - TODO: ds-types-bump
          value: styleValues.value,
          // @ts-expect-error - TODO: ds-types-bump
          unit: styleValues.unit,
        };
        // @ts-expect-error - TODO: ds-types-bump
      } else if (acc.fontSize.value !== styleValues.value) {
        acc.isMixedFontSize = true;
      }
    }

    if (styleValues.type === 'HexColor') {
      if (!acc.fontColor.value) {
        acc.fontColor = styleValues;
      } else if (acc.fontColor.value !== styleValues.value) {
        acc.isMixedFontColor = true;
      }
    }

    if (styleValues.type === 'Keyword') {
      if (!acc.fontFamily) {
        acc.fontFamily = styleValues.value;
      } else if (acc.fontFamily !== styleValues.value) {
        acc.isMixedFontFamily = true;
      }
    }

    return acc;
  });

  if (!GroupPreviewComponent) {
    return null;
  }

  return (
    <GroupPreviewComponent
      value={{
        ...groupComponentProps,
        themeName: groupComponentProps.themeName,
      }}
      onClick={props.onSelect}
    />
  );
};

export default TextLobbyItem;
